import { Component, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { SnapshotService } from '../Services/snapshot.service';
import { Piechart15Component } from '../modules/pie-chart/pie-chart/components/piechart15/piechart15.component';
import { Barchart01Component } from 'src/app/common/charts/VerticalBarChart/vertical-bar-chart.component';
import { Piechart12Component } from '../modules/pie-chart/pie-chart/components/piechart12/piechart12.component';
import * as _ from 'lodash';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-widget-outputview',
  templateUrl: './widget-outputview.component.html',
  styleUrls: ['./widget-outputview.component.css']
})
export class WidgetOutputviewComponent implements OnInit, OnChanges {
  @Input() outputData: any;
  @Input() widgetInfo: any;
  @Input() baseSelected: any;
  @Input() moduleLists: any; //first will come from output.ts only initial selection later modulelist will come from header selection in nav bar 
  @Input() sortToggle:any;
  pageCounter = this._configService.pageCounter;
  inputPopup = false;
  infoTextTitle = '';
  infoTextMessage = '';

  newWidgetData: any;
  item: any;
  items: any;

  itemTrend: any;
  trendItems: any;
  pagesPerSection: any;
  height: any;
  showChart: boolean = false;
  private inputChanges = new Subject<any>();
  private subscriptions: Subscription = new Subscription();
  constructor(public _configService: SnapshotService, private componentFactoryResolver: ComponentFactoryResolver) { }
  outputdata: any = [];
 showPageNav: boolean = true;
  ngOnInit() {
    this.showPageNav = (this._configService.showWidget2Page && this._configService.showWidget1Page);
    // this._configService.getSnapshotOutput(this._configService.outputParameter).subscribe((outputdata: any) => {
    //   let data = outputdata
    //   
    //   
    //   
    //   this.outputdata = JSON.parse(data.Data);
    //   if (data.Data != "") {
    //     this.pageCounter.subscribe(pageCounterValue => {
    //       this.processData(this.widgetInfo, this.moduleLists, pageCounterValue);
    //     });
    //   }
    // })
    if (this._configService.standardSnapOutputData.length > 0) {
      
      this.outputdata = this.outputData;
      this.subscriptions.add(
      this.pageCounter.subscribe(pageCounterValue => {
        this.processData(this.widgetInfo, this.moduleLists, pageCounterValue);
      }));
    }
    this.inputChanges.pipe(debounceTime(300)).subscribe((debouncedChanges) => {
      const dataChanged = debouncedChanges['outputData'] && debouncedChanges['outputData'].currentValue !== undefined;
      const widgetInfoChanged = debouncedChanges['widgetInfo'] && debouncedChanges['widgetInfo'].currentValue !== undefined;
      const moduleListsChanged = debouncedChanges['moduleLists'] && debouncedChanges['moduleLists'].currentValue !== undefined;

      if (widgetInfoChanged || moduleListsChanged || dataChanged) {
        const widgetInfo = widgetInfoChanged ? debouncedChanges['widgetInfo'].currentValue : this.widgetInfo;
        const moduleLists = moduleListsChanged ? debouncedChanges['moduleLists'].currentValue : this.moduleLists;
        this.checkForChanges(widgetInfo, moduleLists);
      }
    });


    const screenHeight = window.innerHeight; // Get the screen width

    this.height = '48%';
    if (screenHeight <= 610) {
      this.height = '10.5rem';
    } else if (screenHeight <= 800) {
      this.height = '10.5rem';
    } else if (screenHeight <= 1200) {
      this.height = '14.3rem';
    }

    document.querySelectorAll('.staticText').forEach((element: any) => {
      const maxChars = 125;
      if (element.textContent.length > maxChars) {
        element.classList.add('multiline');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showPageNav = (this._configService.showWidget2Page && this._configService.showWidget1Page);
    this.inputChanges.next(changes);

  //   this.inputChanges.pipe(debounceTime(300)).subscribe((debouncedChanges) => {
  //   const dataChanged = changes['outputData'] && changes['outputData'].currentValue !== undefined;
  //   const widgetInfoChanged = changes['widgetInfo'] && changes['widgetInfo'].currentValue !== undefined;
  //   const moduleListsChanged = changes['moduleLists'] && changes['moduleLists'].currentValue !== undefined;

  //   if (widgetInfoChanged || moduleListsChanged || dataChanged) {
  //     const widgetInfo = widgetInfoChanged ? changes['widgetInfo'].currentValue : this.widgetInfo;
  //     const moduleLists = moduleListsChanged ? changes['moduleLists'].currentValue : this.moduleLists;
  //     this.checkForChanges(widgetInfo, moduleLists);
  //   }
  // })
};

  private checkForChanges(widgetInfo?: any, moduleLists?: any) {
    widgetInfo = widgetInfo || this.widgetInfo;
    moduleLists = moduleLists || this.moduleLists;
    if (this._configService.standardSnapOutputData.length > 0) {
      
      this.outputdata = this.outputData;
      this.subscriptions.add(
      this.pageCounter.subscribe(pageCounterValue => {
        this.processData(widgetInfo, moduleLists, pageCounterValue);
      }));
    }
  }

  processData(widgetInfo: any, moduleLists: any, pageCounter: any) {
    this.newWidgetData = [];
    this._configService.listOfPptChartObjects = [];

    moduleLists.forEach((module: any) => {
      if (module.isSelected) {
        this.newWidgetData = widgetInfo.filter((item: any) => item.sections === module.name);
      }
    });

    this.pagesPerSection = this.newWidgetData[0]?.widgetPageConfiguration.length;

    
    this.item = this._configService.allPageOutputDataWithoutTrend.filter((config: any) => config.pageNumber === pageCounter);
    this.items = _.cloneDeep(this.item[0].pagewidgetdetails.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber));

    this.items.forEach((item: any) => {
      item.metric.forEach((itemLev1: any) => {

        if (itemLev1.metricSelected.groups == '' && itemLev1.metricSelected.metrics.length > 0) {
          let allMetricsNull = true;
          itemLev1.metricSelected.metrics.forEach((metric: any) => {
            const outputRow = _.cloneDeep(this.outputData.find((row: any) => row.rowChild.includes(metric.metricName) && row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName));
            
            if (this.baseSelected.toLowerCase() != "total base" ? outputRow?.answerWeightedShare !== null : outputRow?.totalWeightedShare !== null) {
              allMetricsNull = false;
            }
          });
          if (allMetricsNull) {
            item.metric = [];
            item.noData = true;
          }
        }
        else if (itemLev1.metricSelected.groups != '' && itemLev1.metricSelected.metrics.length == 0) {
          let allMetricsNull = true;
          const metrics = this.outputData.filter((row: any) => row.widgetNumber == item.widgetNumber && item.widgetName == row.widgetName);
          if (metrics.length > 0) {
            metrics.forEach((metric: any, index: number) => {
            
              if (this.baseSelected.toLowerCase() != "total base" ? metric?.answerWeightedShare !== null : metric?.totalWeightedShare !== null) {
                allMetricsNull = false;
              }
            });
            if (allMetricsNull) {
              item.metric = [];
              item.noData = true;
            }
          }
        }
        else if (itemLev1.metricSelected.groups == '' && itemLev1.metricSelected.metrics.length == 0) {
          item.metric = [];
        }
      })
    });


    this.itemTrend = this._configService.allPageOutputData.filter((config: any) => config.pageNumber === pageCounter);
    this.trendItems = _.cloneDeep(this.itemTrend[0].pagewidgetdetails.sort((a: any, b: any) => a.widgetNumber - b.widgetNumber));



    //this.showChart = false;
    //setTimeout(() => {
      this.showChart = true;
    //}, 100)
 
    //Sorting enabling disabling for("Widget not configured")
    this.items = this.items.map((item: any) => {
      // Replace this condition with your actual logic
      if (item.metric.length < 1 && item.noData == undefined) {
        item.isSort = 0;
      } else {
        item.isSort = 1;
      }
      return item;
    });
  }

  handlemetricname(metricName: any) {
    const parts = metricName.split('|');

    if (parts.length <= 2) {
      return metricName;
    }

    return parts.slice(-2).join('|').trim();
  }

  // showInputPopup(item: any) {
  //   this.inputPopup = true;
  //   this.infoTextTitle = item.widgetName;
  //   this.infoTextMessage = item.infoIcon;
  // }
  ClickedIconFun(data: any) {
    this.inputPopup = data;
  }

  // onCloseIconClick(data: any) {
  //   this.inputPopup = false;
  //    ;
  // }

  @Output() paginationCounter = new EventEmitter<number>();

  paginationCounterFun(pageNum: number) {
    this.pageCounter.next(pageNum);
    if (pageNum === 2) {
      this._configService.page2ToggleSubject.next(pageNum);
    }
    this.paginationCounter.emit(pageNum);

    ;
  }

  steps: any = [
    {
      label: '05 Pie',
      component: Piechart15Component,
    },
    // {
    //   label: 'Vertical Bar',
    //   component: Barchart01Component,
    // },
    {
      label: '02 Pie ',
      component: Piechart12Component,
    },
    //  {
    //   label: 'label',
    //   component: RecommendedComponent,
    // },
  ]
  trackById(index: number, item: any): number {
    return item.id;
  }

  getComponentByLabel(label: string): any {
    const step = this.steps.find((step: any) => step.label === label);
    return step ? step.component : null;
  }

  //------------------------------------SOrting functionality------------------------

  sortWidget(data: any) {
    if (this._configService.standardSnapOutputData.length > 0) {
      this.outputdata = this.outputData;
      // this.pageCounter.subscribe(pageCounterValue => {
      //   this.processData(this.widgetInfo, this.moduleLists, pageCounterValue);
      // });
    }
    for (let i = 0; i < this.item.length; i++) {
      for (let j = 0; j < this.item[i].pagewidgetdetails.length; j++) {
        if (this.item[i].pagewidgetdetails[j].widgetNumber == data.tempItem.widgetNumber) {
          this.item[i].pagewidgetdetails[j] = _.cloneDeep(data.tempItem);
        }
      }
    }
    this.items = _.cloneDeep(this.item[0].pagewidgetdetails);

  }

  //This code is wriiten to make default sorting of widget on page toggle
  defaultSortWidget(tempItem: any) {
    if (this._configService.standardSnapOutputData.length > 0) {
      this.outputdata = this.outputData;
      // this.pageCounter.subscribe(pageCounterValue => {
      //   this.processData(this.widgetInfo, this.moduleLists, pageCounterValue);
      // });
    }

    for (let i = 0; i < this.item.length; i++) {
      for (let j = 0; j < this.item[i].pagewidgetdetails.length; j++) {
        if (this.item[i].pagewidgetdetails[j].widgetNumber == tempItem.widgetNumber) {
          this.item[i].pagewidgetdetails[j] = _.cloneDeep(tempItem);
        }
      }
    }
    this.items = _.cloneDeep(this.item[0].pagewidgetdetails);
  }
  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();
  }

  //----------------------------------------------------------------------------
}